import React, {useEffect, useState} from "react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {Typography, Box, CircularProgress, FormControl, InputLabel, Select, MenuItem, TextField, Autocomplete} from "@mui/material";
import { useDeviceManagement } from "../hooks/useDeviceManagement";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component";
import { useGate } from "../hooks/useGate";

const UpdateDeviceDialog = (props) => {
    const {open, setOpen, selectedDevice} = props;

    const {isUpdatingDevice, updateDevice} = useDeviceManagement();

    const [model, setModel] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [osVersion, setOsVersion] = useState("");
    const [gate_uid, setGateUID] = useState("");
    const [selectedGate, setSelectedGate] = useState("");

    const {gateFilterList, gateList, loading} = useGate();

    useEffect(()=>{
        gateFilterList();
    },[])

    
    const handleClose = () => {
        setOpen(false);
    }

    const allowedPattern = /^[a-zA-Z0-9 _-]*$/;


    const handleChange = (setter) => (event) => {
        const value = event.target.value;
        const filteredValue = value.replace(/[^a-zA-Z0-9 _-]/g, ''); // Only letters, numbers, space, underscore, dash
        setter(filteredValue);
    };

    const blockSpecialChars = (event) => {
        const allowedPattern = /^[a-zA-Z0-9 _-]$/;
        if (!allowedPattern.test(event.data)) {
            event.preventDefault();
        }
    };




    const handleUpdateStatus = () => {

        const parameters ={
            deviceId: selectedDevice.device_id,
        }

        const payload = {
           model: model ? model : selectedDevice?.model,
           manufacturer: manufacturer ? manufacturer : selectedDevice?.manufacturer,
           os_version: osVersion ? osVersion : selectedDevice?.os_version,
        //    gate_uid: selectedGate
        }

        console.log('get payload for update status', payload)

        updateDevice(parameters, payload, setOpen)

    }

    const actions = [
        {
            label: "Update",
            onClick: (e) => 
                (handleUpdateStatus(e))
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={ handleClose}
                title={<Typography sx={{fontWeight: 500}}>Update Device</Typography>}
                hasDividers={true}
                content={
                    <Box sx={{pl: 2, pr: 2}}>
                        <TextField label="Model" variant="standard" sx={{'& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                border: 'none',
                            },},}} 
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }} fullWidth
                            defaultValue={model ? model : selectedDevice?.model}
                            onChange={handleChange(setModel)}
                            onBeforeInput={blockSpecialChars}
                            // error={!!userErrors.email}
                            // helperText={userErrors.email}
                        />
                        <TextField label="Manufacturer" variant="standard" sx={{'& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                border: 'none',
                            },}, mt: 2}} 
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }} fullWidth
                            defaultValue={manufacturer ? manufacturer : selectedDevice?.manufacturer}
                            onChange={handleChange(setManufacturer)}
                             onBeforeInput={blockSpecialChars}
                            // error={!!userErrors.email}
                            // helperText={userErrors.email}
                        />
                        <TextField label="OS Version" variant="standard" sx={{'& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                border: 'none',
                            },}, mt: 2}} 
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }} fullWidth
                            defaultValue={ osVersion ? osVersion : selectedDevice?.os_version}
                            onChange={handleChange(setOsVersion)}
                             onBeforeInput={blockSpecialChars}
                            // error={!!userErrors.email}
                            // helperText={userErrors.email}
                        />
                        {/* <Autocomplete
                            sx={{mt: 2}}
                            options={gateList}
                            getOptionLabel={(option) => option.gatename || ''}
                            value={gateList.find(g => g.gate_uid === selectedGate) || null}
                            onChange={(event, newValue) => {
                                setSelectedGate(newValue ? newValue.gate_uid : null);
                            }}
                          
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Gate Name"
                                    variant="standard"
                                    placeholder={selectedDevice?.gateEntity?.gatename}
                                    fullWidth
                                    // error={!!gatepassErrors.driver_name}
                                    // helperText={gatepassErrors.driver_name}
                                />
                            )}
                        /> */}
                    </Box>
                }
                actions={actions}
                maxWidth={"sm"}
                customStyles={{
                    actions: {
                        opacity: (!isUpdatingDevice) ? "100%" : "55%",
                        cursor: (!isUpdatingDevice) ? "pointer" : "not-allowed !important",
                        visibility: (isUpdatingDevice) ? "aaaaaaaaaaaaaa" : "visible",
                    }
                }}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateDeviceDialog
